import loadingImage from "../../../assets/newLoadingSpinner.svg";
import filledLogoOld from "../../../assets/logo-old.png";
import styles from "./styles.module.scss";
import { circadiaEngineProvider } from "../../../AppController";
import classNames from "classnames";

export const ScreenLoaderWhite = () => {
  circadiaEngineProvider.changeAppTopAndBottom("#ffffff", "#ffffff");
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.filledWrapper}>
        <img
          src={loadingImage}
          alt="loading logo"
          className={styles.loadingImage}
        />

        <h6 className={classNames(styles.loadingText, " my-3")}>Loading</h6>
      </div>
      <div className={`${styles.textLoader} pb-5`}>
        <img
          src={filledLogoOld}
          style={{ maxWidth: "188px" }}
          alt="filled-logo"
        />
      </div>
    </div>
  );
};
